import { Styles, generateClasses } from '@lsy-netline/netline-ui';

export const errorViewClasses = generateClasses('ErrorView', [
  'root',
  'logo',
  'container',
  'title',
  'message',
  'actions',
  'details',
] as const);

export const errorViewLogoClasses = generateClasses(errorViewClasses.logo, ['custom'] as const, true);

const styles: Styles = ({ theme: { spacing, breakpoints } }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  [`.${errorViewClasses.logo}`]: {
    width: `calc(100% - ${spacing(4)})`,
    maxWidth: 440,
    height: 'auto',
    marginTop: spacing(16),
    [breakpoints.down('sm')]: {
      marginTop: spacing(8),
    },
    [`&.${errorViewLogoClasses.custom}`]: {
      marginTop: 0,
    },
    marginBottom: spacing(4),
  },
  [`.${errorViewClasses.container}`]: {
    maxWidth: 472,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    minHeight: 0,
  },
  [`.${errorViewClasses.title}`]: {
    marginTop: spacing(2),
  },
  [`.${errorViewClasses.message}`]: {
    marginTop: spacing(4),
  },
  [`.${errorViewClasses.actions}`]: {
    marginTop: spacing(4),
  },
  [`.${errorViewClasses.details}`]: {
    flex: '1 0 0',
    marginTop: spacing(4),
    marginBottom: spacing(4),
  },
});

export default styles;
